/**
 * Live presence client (#228 Phase 2). A best-effort heartbeat: while a tab is
 * open it posts the tab's presence session id to /api/presence/ping on a fixed
 * cadence. Identity (user/tenant) is taken server-side from the token, never the
 * body. A failed ping is silent and non-blocking — a dropped beat just ages the
 * row offline.
 */
import { authHeaders } from "./auth";

const PRESENCE_SESSION_KEY = "cyclecare.presence.session";

/** A stable per-tab presence id (sessionStorage so each tab is distinct). */
export function presenceSessionId(): string {
  let id = sessionStorage.getItem(PRESENCE_SESSION_KEY);
  if (id === null) {
    id = typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : `p_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(PRESENCE_SESSION_KEY, id);
  }
  return id;
}

/** Send one heartbeat. Best-effort: resolves even on failure (never throws). */
export async function sendPresencePing(): Promise<void> {
  try {
    await fetch("/api/presence/ping", {
      method: "POST",
      headers: authHeaders({ "Content-Type": "application/json" }),
      body: JSON.stringify({ sessionId: presenceSessionId() }),
      keepalive: true
    });
  } catch {
    // Best-effort: a dropped ping just ages last_seen; nothing to surface.
  }
}
